import { classnames } from '@/helpers';
import { AnchorHTMLAttributes } from 'react';
import { Link } from 'react-router-dom';
import { twMerge } from 'tailwind-merge';

type NavLinkProps = {
  to?: string | { pathname: string; search?: string; state?: any };
  className?: string;
  children?: React.ReactNode;
} & AnchorHTMLAttributes<HTMLAnchorElement> &
  React.ButtonHTMLAttributes<HTMLButtonElement>;

const STYLE: React.CSSProperties = {
  height: 40,
} as const;

const defaultClassNames =
  'inline-block leading-[40px] text-l text-fg_link hover:text-fg_link_hover hover:underline disabled:fg-disabled active:fg-link_pressed outline-none focus:underline focus:text-fg_link_hover' as const;

const NavLink = ({ to, className: _className, children, ...props }: NavLinkProps) => {
  const className = twMerge(classnames(defaultClassNames, _className));

  if (!to) {
    return (
      <button {...props} className={className}>
        {children}
      </button>
    );
  }

  const isInternalLink = (typeof to === 'string' && to.startsWith('/')) || typeof to === 'object';

  if (isInternalLink) {
    return (
      <Link {...props} to={to} className={className} style={props.style ?? STYLE}>
        {children}
      </Link>
    );
  }

  return (
    <a {...props} href={to} className={className} style={props.style ?? STYLE}>
      {children}
    </a>
  );
};

export default NavLink;
